<mat-form-field
  [appearance]="appearance"
  class="mb-0 pb-0 form-field"
  [ngClass]="{
    'form-field--small': size === 'xs',
    'readonly': readonlyState,
    'theme--disabled': disabled,
    'form-field--unbounded': theme === 'unbounded',
    'theme--highlighted': theme === 'highlighted',
    'theme--outlined': theme === 'outlined'
    }"
>
  <div class="form-field__prefix" matPrefix>
    <span [hidden]="multiple && selectedCount">
      <ng-content select="[prefix]"></ng-content>
    </span>
    <span class="lazy-dropdown__rect" *ngIf="multiple && selectedCount">{{selectedCount}}</span>
  </div>
  <div class="form-field__suffix" matSuffix>
    <app-row>
      <app-col cols="auto" *ngIf="loading">
        <app-spinner [small]="true"></app-spinner>
      </app-col>
      <app-col cols="auto">
        <ng-content select="[suffix]"></ng-content>
      </app-col>
    </app-row>
  </div>
  <mat-select
    #matSelect
    [panelClass]="'select--has-min-width'"
    [multiple]="multiple"
    [formControl]="valueControl"
    [placeholder]="placeholder | translate"
    (openedChange)="handleOpenChange($event)"
  >
    <mat-select-trigger #matSelectTrigger>
      <div class="flex box gaps-2 align-center lazy-select-trigger">
        <div class="lazy-select-chips" *ngIf="chips && multiple && selectedOptions.length && !isAllSelected; else plainText">
          <span *ngFor="let option of selectedOptions" class="lazy-select-chip">
            <span class="lazy-select-chip__label">{{option.display | translate}}</span>
            <app-icon
              name="close"
              type="MaterialDesign"
              size="xxs"
              class="lazy-select-chip__remove"
              (click)="removeChip(option.id, $event)"
            ></app-icon>
          </span>
        </div>

        <ng-template #plainText>
          <div class="lazy-select-text">
            <span [ngClass]="{'weight-semibold': highlightSelection }">{{displayText | translate}}</span>
          </div>
        </ng-template>

        <div *ngIf="clearable" class="lazy-select-clear">
          <app-icon name="close" type="MaterialDesign" (click)="clearValue($event)" size="xs" class="align-middle text-300"></app-icon>
        </div>
      </div>
    </mat-select-trigger>


    <div class="dropdown dropdown--lazy">
      <app-dropdown-search class="dropdown__search" [ngModel]="searchTerm$.value" (ngModelChange)="searchTerm$.next($event)" [ngModelOptions]="{standalone: true}"></app-dropdown-search>

      <div class="dropdown__scroll" #scrollElement>
        <mat-option
          *ngIf="allowAddNew && !optionIds?.length"
          class="dropdown__option--hidden p-0"
          [disabled]="true"
        ></mat-option>

        <div class="dropdown__options px-1" *ngIf="optionIds?.length">
          <mat-option
            *ngFor="let optionId of optionIds; let i = index"
            class="dropdown__option"
            [class.dropdown__option--highlighted]="options[optionId].highlighted"
            [class.dropdown__option--hidden]="!isOptionVisible(optionId, (searchTerm$ | async)?.toString().trim())"
            [value]="optionId"
            [disabled]="options[optionId].disabled"
          >
            <ng-container *ngIf="optionLabelDirective; else defaultOptionLabel">
              <ng-container
                *ngTemplateOutlet="optionLabelDirective.templateRef; context: { $implicit: options[optionId]?.option, index: i }"
              ></ng-container>
            </ng-container>

            <ng-template #defaultOptionLabel>
              <div class="dropdown__option-row">
                <span
                  class="dropdown__option-checkbox"
                  [class.dropdown__option-checkbox--checked]="options[optionId].selected"
                >
                  <app-icon
                    *ngIf="options[optionId].selected"
                    name="check"
                    type="MaterialDesign"
                    size="xxs"
                    class="dropdown__option-checkbox-icon"
                  ></app-icon>
                </span>
                <div class="dropdown__option-text">
                  <span class="dropdown__option-title">{{(options[optionId].display || '') | translate}}</span>
                  <span class="dropdown__option-description" *ngIf="options[optionId].description">
                    {{options[optionId].description | translate}}
                  </span>
                </div>
              </div>
            </ng-template>
          </mat-option>
        </div>

        <div class="dropdown__loading pb-2" #loadMoreTrigger>
          <div class="flex align-center justify-center" *ngIf="loading">
            <app-spinner [small]="true"></app-spinner>
          </div>
          <div class="flex align-center text-600 weight-semibold pb-1 pt-6" *ngIf="endOfResult">
            <small class="px-3">{{'General.noMoreResult' | translate}}</small>
            <small class="text-underline text-primary px-3 py-2 ml-auto text-btn" (click)="forceUpdate()">
              {{'General.DontFindNewData' | translate}}
            </small>
          </div>
        </div>
      </div>

      <div class="dropdown__add-new h6 m-0" *ngIf="allowAddNew" (click)="handleAddNewClick($event)">
        <app-icon name="add" type="MaterialDesign" size="xs" class="mr-1"></app-icon>
        <span>{{addNewLabel | translate}}</span>
      </div>
    </div>
  </mat-select>
</mat-form-field>

<div class="error-handler">
  <div class="row align-center">
    <div class="col-auto mr-auto">
      <ng-content select="[error], mat-error, error"></ng-content>
    </div>
    <div class="col-auto ml-auto">
      <mat-hint *ngIf="!optionIds?.length && !loading">{{'General.EmptyList' | translate}}</mat-hint>
    </div>
  </div>
</div>
